<template>
  <div class="updateTenantModal">
    <vs-popup :active.sync="isActiveLocal" :button-close-hidden="false" title="Editar Features" @close="isActiveLocal = false">
      <div class="mb-5">
        <label>Plano</label>
        <v-select
          v-model="enabledPlan"
          :options="defaultPlans"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          class="w-full"
          name="plan"
          label="text"
          placeholder=" "
          :clearable="false"
          :searchable="true"
          :reduce="option => option.value"
        />
      </div>

      <div class="flex flex-row mb-5 justify-between">
        <div>
          <label class="vs-input--label">Limite de Usuários</label>
          <vs-input-number class="userLimit" v-model="userLimit" min="0" max="500"/>
        </div>

        <div>
          <label class="vs-input--label">Limite de Atendimentos</label>
          <vs-input-number class="userLimit" v-model="ticketLimit" min="0"/>
        </div>
      </div>

      <div class="w-full">
        <label>Features</label>
        <div class="featureCheckboxList">
          <template v-for="(key, value) in featureSupport">
            <div v-if="value !== 'catalog' && (value !== 'messaging' || isFuncionalMessagingTenant())" :key="key" class="mb-2">
              <vs-checkbox v-model="currentFeatures[key - 1]" :disabled="value === 'whatsapp' || value === 'messaging' || (enabledPlan && enabledPlan !== 'ON-DEMAND')">
                <span> {{ formattedFeatures[value] }} </span>
              </vs-checkbox>
            </div>
          </template>
        </div>
      </div>

      <vs-button class="mt-2" type="filled" @click="updateFeatures">Salvar</vs-button>
    </vs-popup>

    <div class="w-full" v-if="!isPopup">
      <div class="mb-5">
        <label>Plano</label>
        <v-select
          v-model="enabledPlan"
          :options="defaultPlans"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          class="w-full"
          name="plan"
          label="text"
          placeholder=" "
          :clearable="false"
          :searchable="true"
          :reduce="option => option.value"
        />
      </div>

      <div class="mb-5">
        <label>Parceiro</label> 
        <v-select
          v-model="partnerId"
          :options="partners"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          class="w-full"
          name="plan"
          label="name"
          placeholder=" "
          :clearable="false"
          :searchable="true"
          :reduce="option => option.name"
        />
      </div>

      <div class="flex flex-row mb-5 justify-between">
        <div>
          <label class="vs-input--label">Limite de Usuários</label>
          <vs-input-number class="userLimit" v-model="userLimit" min="0" max="500"/>
        </div>

        <div>
          <label class="vs-input--label">Limite de Atendimentos</label>
          <vs-input-number class="userLimit" v-model="ticketLimit" min="0"/>
        </div>
      </div>

      <div class="w-full">
        <label>Features</label>
        <div class="featureCheckboxList">
          <template v-for="(key, value) in featureSupport">
            <div v-if="value !== 'catalog' && (value !== 'messaging' || isFuncionalMessagingTenant())" :key="key" class="mb-2">
              <vs-checkbox v-model="currentFeatures[key - 1]" :disabled="value === 'whatsapp' || value === 'messaging' || (enabledPlan && enabledPlan !== 'ON-DEMAND')">
                <span> {{ formattedFeatures[value] }} </span>
              </vs-checkbox>
            </div>
          </template>
        </div>
      </div>

      <div class="w-full mt-5 flex justify-center mb-5" v-if="canSee('feature-update')">
        <vs-button type="filled" size="small" @click="updateFeatures">Salvar</vs-button>
      </div>
    </div>
  </div>
</template>

<script>

import vSelect from 'vue-select';
import {hasPermissionBackOffice} from "@/utils";

export default {
  name: 'UpdateTenant',
  emits: ['setState'],
  components: { vSelect },
  data() {
    return {
      userLimit: 0,
      ticketLimit: 0,
      partnerId: null,
      currentFeatures: new Array(13).fill(false),
      featureSupport: {
        'orders': 1,
        'erps': 2,
        'services': 3,
        'catalog': 4,
        'maria': 5,
        'sms': 6,
        'email': 7,
        'boehringer': 8,
        'pharmacovigilance': 9,
        'whatsapp': 10,
        'messaging': 11,
        'crediario': 12,
        'kanban': 13,
      },
      formattedFeatures: {
        'orders': 'Pedidos',
        'erps': 'ERPs',
        'services': 'Serviços',
        'catalog': 'Catálogo', // escondido da tela de planos via v-if; mantido para compatibilidade/rollback
        'maria': 'Maria',
        'sms': 'SMS',
        'email': 'Email',
        'boehringer': 'Boehringer',
        'pharmacovigilance': 'Farmacovigilância',
        'whatsapp': 'Campanhas Whatsapp',
        'messaging': 'Mensageria',
        'crediario': 'Crediário',
        'kanban': 'Kanban',
      }
    }
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
      required: true
    },
    isPopup: {
      type: Boolean,
      required: false,
      default: true
    },
    features: {
      type: Array,
      required: true
    },
    partners: {
      type: Array,
      default: () => [],
      required: true
    },
    currentPartner: {
      type: Object,
      default() { return {}; }
    },
    tenant: {
      required: false,
      validator: prop => typeof prop === 'object' || prop === null,
      default() { return {}; }
    },
    defaultPlans: {
      required: false,
      validator: prop => typeof prop === 'object' || prop === null,
      default() { return []; }
    },
    enabledPlan: {
      required: false,
      validator: prop => typeof prop === 'string' || prop === null,
      default() { return false; }
    }
  },
  computed: {
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(newVal) {
        this.$emit('setState', newVal);
      }
    },
    erpSelected() {
      return this.currentFeatures[1];
    }
  },
  watch: {
    features() {
      this.loadFeatures(true)
    },
    isActiveLocal(newVal) {
      if (newVal) {
        this.userLimit = (this.tenant.user_limit || 0);
        this.ticketLimit = (this.tenant.ticket_limit || 0);
      }
      this.loadFeatures(newVal)
    },
    currentPartner: {
      immediate: true,
      deep: true,
      handler(val) {
        this.partnerId = (val && val.name) ? val.name : null;
      }
    }
  },
  methods: {
    canSee(word) {
      return hasPermissionBackOffice(`tenant-list-${word}`);
    },
    isFuncionalMessagingTenant() {
      if (!this.tenant || !this.tenant.fqdn) {
        return false;
      }

      const tenantName = this.tenant.fqdn.split('.')[0];

      return typeof tenantName === 'string' && tenantName.toLowerCase().includes('funcional-messaging');
    },
    loadFeatures(newVal) {
      this.currentFeatures = new Array(13).fill(false);
      if (newVal && this.features && this.features.length) {
        this.features.forEach(item => {
          if (!['websocket', 'status_notification', 'skip_downgrade_provisioner', 'premium_support', 'campaigns', 'cloud'].includes(item.name)) {
            const slot = this.featureSupport[item.name];
            if (slot == null) {
              return;
            }
            this.currentFeatures[slot - 1] = item.enabled && item.enabled == 'true';
          }
        });
      }
    },
    updateFeatures() {
      if (this.partnerId !== this.currentPartner.name) {
        const selectedPartner = this.partners.find(partner => partner.name === this.partnerId);
        const newPartnerId = selectedPartner ? selectedPartner.id : null;

        if (newPartnerId) {
          this.$emit('updatePartner', newPartnerId);
        }
      }

      if (this.enabledPlan){
        this.$emit('setPlan', { plan: this.enabledPlan, user: this.userLimit, ticket: this.ticketLimit });
        this.$emit('setState', false);
        if (this.enabledPlan !== 'ON-DEMAND') { return; }
      }

      const parsedFeatures = {};
      this.currentFeatures.forEach((value, index) => parsedFeatures[index + 1] = value);

      const computed = [];
      const notComputed = Object.values(this.featureSupport);

      this.features.forEach(feature => {
        const optionId = this.featureSupport[feature.name];
        if (optionId == null) {
          return;
        }
        computed.push(optionId);

        if (parsedFeatures[optionId] === JSON.parse(feature.enabled)) {
          delete parsedFeatures[optionId];
        }
      });

      (notComputed.filter(id => !computed.includes(id))).forEach(id => {
        if (!parsedFeatures[id]) delete parsedFeatures[id];
      });

      this.$emit('setState', false, parsedFeatures);
    },
    refreshDefault(){
      if (this.tenant){
        this.userLimit = (this.tenant.user_limit || 0);
        this.ticketLimit = (this.tenant.ticket_limit || 0);
      }
    }
  },
  mounted() {
    this.refreshDefault()
  }
}
</script>

<style lang="scss">
.featureCheckboxList {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  max-width: 100%;
}

.featureCheckboxList .mb-2 {
  flex: 1 1 calc(50% - 8px);
}

.userLimit {
  width: 7.6em;
}

</style>
